import {IClickSource} from "../interfaces/IClickSource";

const CLICK_SOURCE_PARAM = "cs";
const CLICK_SOURCE_CONTEXT_VAR = "%s";

export const addClickSourceParam = (url: string, clickSource: IClickSource): string => {
  return url.indexOf("?") > 0 ? url + "&" + CLICK_SOURCE_PARAM + "=" + getClickSourceValue(clickSource) :
    url + "?" + CLICK_SOURCE_PARAM + "=" + getClickSourceValue(clickSource);
}

const getClickSourceValue = (clickSource: IClickSource) => {
  let value: string;
  if (clickSource.context) {
    value = clickSource.context.includes(CLICK_SOURCE_CONTEXT_VAR) ?
      clickSource.clickSource.replace(CLICK_SOURCE_CONTEXT_VAR, clickSource.context) :
      clickSource.clickSource + "_" + clickSource.context;
  }
  else {
    value = clickSource.clickSource;
  }

  return value;
}